import { DocumentRelatedPersonsRes } from '@dealstack/shared/lib/generated';

export const getDocumentLinkNames = (
	documentLinks: DocumentRelatedPersonsRes[] | undefined
): string[] =>
	Array.from(
		new Set(
			(documentLinks ?? [])
				.flatMap((link) => [link.name, link.issuerName, link.sellerName, link.buyerName])
				.filter((name): name is string => !!name)
		)
	);
